var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 28.5V22.5H28.5L28.5015 28.5H22.5ZM28.5 19.5H22.5C20.8455 19.5 19.5 20.8455 19.5 22.5V28.5C19.5 30.1545 20.8455 31.5 22.5 31.5H28.5C30.1545 31.5 31.5 30.1545 31.5 28.5V22.5C31.5 20.8455 30.1545 19.5 28.5 19.5ZM7.5 28.5V22.5H13.5L13.5015 28.5H7.5ZM13.5 19.5H7.5C5.8455 19.5 4.5 20.8455 4.5 22.5V28.5C4.5 30.1545 5.8455 31.5 7.5 31.5H13.5C15.1545 31.5 16.5 30.1545 16.5 28.5V22.5C16.5 20.8455 15.1545 19.5 13.5 19.5ZM22.5 13.5V7.5H28.5L28.5015 13.5H22.5ZM28.5 4.5H22.5C20.8455 4.5 19.5 5.8455 19.5 7.5V13.5C19.5 15.1545 20.8455 16.5 22.5 16.5H28.5C30.1545 16.5 31.5 15.1545 31.5 13.5V7.5C31.5 5.8455 30.1545 4.5 28.5 4.5ZM7.5 13.5V7.5H13.5L13.5015 13.5H7.5ZM13.5 4.5H7.5C5.8455 4.5 4.5 5.8455 4.5 7.5V13.5C4.5 15.1545 5.8455 16.5 7.5 16.5H13.5C15.1545 16.5 16.5 15.1545 16.5 13.5V7.5C16.5 5.8455 15.1545 4.5 13.5 4.5Z",
    fill: "#26284D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1707_29460",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 28,
    height: 28
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 28.5V22.5H28.5L28.5015 28.5H22.5ZM28.5 19.5H22.5C20.8455 19.5 19.5 20.8455 19.5 22.5V28.5C19.5 30.1545 20.8455 31.5 22.5 31.5H28.5C30.1545 31.5 31.5 30.1545 31.5 28.5V22.5C31.5 20.8455 30.1545 19.5 28.5 19.5ZM7.5 28.5V22.5H13.5L13.5015 28.5H7.5ZM13.5 19.5H7.5C5.8455 19.5 4.5 20.8455 4.5 22.5V28.5C4.5 30.1545 5.8455 31.5 7.5 31.5H13.5C15.1545 31.5 16.5 30.1545 16.5 28.5V22.5C16.5 20.8455 15.1545 19.5 13.5 19.5ZM22.5 13.5V7.5H28.5L28.5015 13.5H22.5ZM28.5 4.5H22.5C20.8455 4.5 19.5 5.8455 19.5 7.5V13.5C19.5 15.1545 20.8455 16.5 22.5 16.5H28.5C30.1545 16.5 31.5 15.1545 31.5 13.5V7.5C31.5 5.8455 30.1545 4.5 28.5 4.5ZM7.5 13.5V7.5H13.5L13.5015 13.5H7.5ZM13.5 4.5H7.5C5.8455 4.5 4.5 5.8455 4.5 7.5V13.5C4.5 15.1545 5.8455 16.5 7.5 16.5H13.5C15.1545 16.5 16.5 15.1545 16.5 13.5V7.5C16.5 5.8455 15.1545 4.5 13.5 4.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1707_29460)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "#26284D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.b5659fb8ae197a7c507f2ea35779e4ff.svg";
export { ForwardRef as ReactComponent };